/** In-dashboard selection (Power BI–style); narrows customer table + charts, not the group tree. */
export type BandwidthCrossFilterSlice =
  | null
  | { kind: 'user'; id: string }
  | { kind: 'group'; id: string }
  | { kind: 'customer'; id: string };

export function bandwidthCrossFilterQueryKey(slice: BandwidthCrossFilterSlice): string {
  if (!slice) return 'none';
  return `${slice.kind}:${slice.id}`;
}
